import React from 'react';
import styled from 'styled-components';
import { Icon } from './Icon';

export function TopButton(props) {
  return (
    <Wrap
      onClick={() =>
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }
    >
      <Icon name="arrow" $pathStroke="primary" $strokeOpacity={1} $transform="rotate(-180deg)" />
    </Wrap>
  );
}

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 10%;
  right: 10%;
  width: 56px;
  height: 56px;
  background-color: white;
  z-index: 30;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.lightest};
  cursor: pointer;
  transition: all 150ms ease;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.16);

  &:hover {
    opacity: 0.6;
  }
`;
